export default __webpack_public_path__ + "static/solid-new-9c8b475d309e7d78ee484746d65ee6ed.svg";